













































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import InvestigateApi from '@/api/investigate'
import BillApi from '@/api/bill'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'

@Component({
	name: 'billTaskList',
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []
	private visible: boolean = false

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	private taskDetailPwd(action: any) {
		return `/bill/taskDetail/${action.orderId}`
	}

	public getList() {
		return BillApi.getList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.$store.dispatch('setting/initCompanyTree').then((res: any) => {
			this.setCompanyAsTree()
		})
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.createTime =
			form.rangeTime &&
			form.rangeTime[0] &&
			form.rangeTime[0].format('YYYY-MM-DD')
		form.endTime =
			form.rangeTime &&
			form.rangeTime[1] &&
			form.rangeTime[1].format('YYYY-MM-DD')
		delete form.rangeTime
		let temp =
			typeof form.company.value === 'string'
				? form.company.value.trim()
				: form.company.value
		if (temp || temp === 0) {
			form.companyId = temp
		}
		delete form.company

		return form
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
